import { useEffect, useState } from 'react';

/** Sayt koʻrinishi shu kenglikdan boshlanadi. CSS bilan BIR XIL. */
export const WIDE_PX = 1000;

/**
 * Ekran keng (kompyuter) ekanligini aytadi.
 *
 * NEGA JS KERAK, CSS YETARLI EMAS: media soʻrovi elementni koʻrsatib
 * yoki yashira oladi, lekin BOSHQA TUZILMA chiza olmaydi. Dars
 * ekranida saytga doimiy darslar roʻyxati kerak — bu esa qobiqning
 * oʻzi boshqacha boʻlishi degani, koʻrinish emas.
 *
 * DIQQAT — chegara CSS dagi bilan bir xil boʻlishi SHART (1000px).
 * Farq qilsa, ikkalasi bir-biriga zid holatga tushadi: masalan CSS
 * yon panelni koʻrsatadi-yu, JS hali "tor" deb hisoblaydi.
 *
 * `matchMedia` ishlatiladi, `resize` emas: brauzer faqat chegaradan
 * oʻtilganda xabar beradi, har piksel uchun emas.
 */
export function useWideScreen(): boolean {
  const [wide, setWide] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(`(min-width: ${WIDE_PX}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(`(min-width: ${WIDE_PX}px)`);
    const onChange = (e: MediaQueryListEvent) => setWide(e.matches);
    mq.addEventListener('change', onChange);
    // Boshlangʻich qiymat oʻzgargan boʻlishi mumkin (SSR, qayta ulanish).
    setWide(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return wide;
}
